import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo";
import { ExternalLink } from "lucide-react";

export const Route = createFileRoute("/links")({
  head: () =>
    seoHead({
      path: "/links",
      title: "Helpful Links — Coffman Cove Lodging",
      description:
        "Useful links for planning your Prince of Wales Island trip: ferries, air carriers, fishing regulations, local government, and outdoor resources.",
    }),
  component: LinksPage,
});

type LinkEntry = { label: string; url: string; note?: string };

const LINKS: LinkEntry[] = [
  { label: "City of Coffman Cove", url: "https://www.coffmancove.org" },
  {
    label: "Alaska Department of Fish and Game",
    url: "https://www.adfg.alaska.gov",
  },
  { label: "POW Fishing Guide", url: "https://www.princeofwalesfishing.com" },
  { label: "Alaska Airlines", url: "https://www.alaskaair.com" },
  {
    label: "Alaska Interisland Ferry",
    url: "https://www.interislandferry.com",
  },
  { label: "Taquan Air", url: "https://www.taquanair.com" },
  { label: "Pacific Airways", url: "https://www.flypacificairways.com" },
  { label: "Island Air Express", url: "https://www.flyislandair.com" },
  {
    label: "Alaska Marine Highway System",
    url: "https://dot.alaska.gov/amhs/",
  },
  {
    label: "Prince of Wales Chamber of Commerce",
    url: "https://www.princeofwalescoc.org",
  },
  { label: "Hewescraft Boats", url: "https://www.hewescraft.com" },
  {
    label: "Alaska Outdoor Directory",
    url: "https://www.alaskaoutdoors.com",
  },
  {
    label: "El Capitan Caves",
    url: "https://www.fs.usda.gov/recarea/tongass/recarea/?recid=78889",
  },
  {
    label: "Tongass National Forest",
    url: "https://www.fs.usda.gov/tongass",
  },
];

function LinksPage() {
  return (
    <div className="mx-auto max-w-4xl px-4 sm:px-6 py-12">
      <header className="mb-8">
        <p className="uppercase tracking-[0.3em] text-xs text-[oklch(0.78_0.13_35)]">
          Plan Your Trip
        </p>

        <h1 className="font-display text-4xl md:text-5xl mt-3 text-balance text-foreground">
          Helpful Links
        </h1>

        <p className="mt-3 text-muted-foreground max-w-2xl">
          Resources for planning your trip to Coffman Cove and Prince of Wales
          Island — travel, fishing regulations, local government, and outdoor
          references.
        </p>
      </header>


      <ul className="grid gap-3 sm:grid-cols-2">
        {LINKS.map((link) => (
          <li key={link.url}>
            <a
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center justify-between gap-3 rounded-lg border border-white/20 bg-card px-4 py-3 shadow-sm transition hover:border-[var(--color-ember)] hover:bg-[var(--color-ember)]/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-ember)]"
            >
              <span className="font-medium text-foreground group-hover:text-[var(--color-ember)]">
                {link.label}
              </span>
              <ExternalLink className="h-4 w-4 text-foreground/80 group-hover:text-[var(--color-ember)]" />
            </a>


          </li>
        ))}
      </ul>

      <p className="mt-10 text-xs text-muted-foreground">
        External links open in a new tab. Coffman Cove Lodging is not
        responsible for the content of third-party websites.
      </p>
    </div>
  );
}
